import { ChangeDetectorRef, Component } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ApiserviceService } from "../../apiservice.service";
import { NotificationService } from "../services/notification.service";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatOptionSelectionChange,
} from "@angular/material/core";
import { CommonfunctionService } from "../../services/commonfunction.service";
import * as _moment from "moment";
import { AdminMenusService } from "../admin-sidebar/admin-menus.service";
import { GisDataService } from "../gis-data-upload/gis-data-upload.service";
import { Subject } from "rxjs";
import { layerListOptions } from "./model/layer-list-options.model";
import { GEOMETRY_TYPES, StatusOptions } from "./model/status-options.model";
import { MatDialog } from "@angular/material/dialog";
import { ProcessExecutionTrackerComponent } from "./components/process-execution-tracker/process-execution-tracker.component";
// tslint:disable-next-line:no-duplicate-imports
// import { default as  Moment } from 'moment';

const moment = _moment;

// See the Moment.js docs for the meaning of these formats:
// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: "YYYY",
  },
  display: {
    dateInput: "YYYY",
    monthYearLabel: "YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "YYYY",
  },
};
@Component({
  selector: "app-spark-calculate-sync",
  templateUrl: "./spark-calculate-sync.component.html",
  styleUrls: ["./spark-calculate-sync.component.scss"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class SparkCalculateSyncComponent {
  multiple:boolean=true;
  sub_categories: string[] = [];
  layerDataGroup: FormGroup;
  neighbourhoods: any[];
  selectedYear = new Date().getFullYear();
  loader: boolean = false;
  searchNeigh: string = "";
  blocks: any[];
  selectedBlock: any[] = [];
  selectedneightUid: any;
  layerListData: [] = [];
  layerTableContent = {};
  isPanelOpen = false;
  layerListOptions = layerListOptions;
  status_options = StatusOptions;
  GEOMETRY_TYPES = GEOMETRY_TYPES
  selectedNeighs: any;
  startYear: number;
  currentYear: number;
  selected: string = '';
  offset: number = 0;
  limit: number = 10;
  pageIndex: number = 0;
  date = new FormControl(moment());
  totalCount: any;
  is_admin: boolean = false;
  filter_list_data: any;
  filteredStatus: any[];
  isCalculating: boolean = false;
  list: Subject<void> = new Subject<void>();
  calculate_access = {
    GET: false,
    POST: false,
    PATCH: false,
    DELETE: false,
  };
  isServerRunning: boolean = false;
  selectedData: any;
  selectedNeighsthis: any;
  selectedNeighName: any;
  selectedBlockName: any;
  selectedGeometryType: any;
  // store all selected neighbourhood UIDs
persistedSelectedNeighs: string[] = [];
  ctrlAProcessing: any;
  constructor(
    private fb: FormBuilder,
    private api: ApiserviceService,
    private notify: NotificationService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private active: GisDataService,
    private menus: AdminMenusService,
    private fnc: CommonfunctionService,
    private cdr: ChangeDetectorRef,
    private readonly dialog: MatDialog
  ) {
    iconRegistry.addSvgIcon(
      "filter-icon",
      sanitizer.bypassSecurityTrustResourceUrl("assets/icon/filter-icon.svg")
    );
    this.menus.setActive("spark-calculate-sync");
    this.active.setActive("");
  }

  ngOnInit() {
    this.init();
    this.currentYear = new Date().getFullYear();
    this.startYear = 2009;
    this.layerDataGroup.patchValue({
      layerName: this.layerListOptions[0].value,
    });
    this.getAllowResourcesApi();
  }

  /**
   * Form initialize
   */

  // getting allow resources
  getAllowResourcesApi() {
    this.api.getUserRole();
    let body = `user/resource?place_id=${this.api.city_id}&user_id=${this.api.user_id}`;
    this.api.getUmsData(body).subscribe((res: any) => {
      this.api.allowResources = res.data;
      this.getAllowResource();
      this.getNeighbourhoods();
      this.getLayerData(null, null, true);
      this.getSyncStatus();
    });
  }

  getAllowResource() {
    this.calculate_access = this.fnc.checkResourceAccess(
      "spark_calculate_sync",
      false
    );
  }
  init() {
    this.layerDataGroup = this.fb.group({
      neighborhood: ["", Validators.required],
      year: [],
      layerName: [""],
      block: [{ value: null, disabled: false }],
      distance: [""],
      filter_neighborhood: [null],
      status: [null],
      sub_categories: [[]],
      zoning:[[]],
      geometryTypes:[[]],


    });
  }
  /**
   * getting Neighborhood drop down list
   * @param processName
   */
getNeighbourhoods(processName?: string) {
  this.neighbourhoods = [];
  let url = `neighbourhoods/json`;
  let sparkUrl = `spark/neighbourhoods`;

  if (processName) {
    sparkUrl += `?year=${this.selectedYear}&process_name=${processName}`;
  } else if (this.selectedYear) {
    url += `?year=${this.selectedYear}`;
  }

  this.loader = true;
  const apiUrl = processName ? sparkUrl : url;

  this.api.getGpsData(apiUrl).subscribe({
    next: (res: any) => {
      this.loader = false;
      if (res?.status === 200 && Array.isArray(res?.data) && res.data.length) {
        this.neighbourhoods = res.data;
      }
      else if (Array.isArray(res) && res.length) {
        this.neighbourhoods = res;
      }
      else {
        this.neighbourhoods = [];
      }
    },
    error: () => {
      this.loader = false;
      this.neighbourhoods = [];
    },
  });
}




  /**
   *
   * @param neigh selecting neighbourhoods and send null block after select neighbourhood
   */
  /**
 * Handles neighborhood selection changes
 */
// REPLACE your current selectedNeigh() method with this:

selectedNeigh(selected: string[]) {
  console.log(selected, "selected");

  // Use what mat-select gives us
  const current = selected || [];

  // Update all your state arrays
  this.selectedNeighs = current;
  this.persistedSelectedNeighs = current;

  // Get names for display
  const matchedNames = this.neighbourhoods
    .filter(n => current.includes(n.neigh_uid))
    .map(n => n.neigh_name);
  this.selectedNeighName = matchedNames.join(",");

  // Reset block if none selected
  if (!current.length) {
    this.layerDataGroup.patchValue({ block: "" });
    return;
  }

  // Get blocks for selected
  this.getBlocks(current);
}
selectOne(checked: boolean, uid: string) {
console.log(uid);
 this.getBlocks(uid);
  if (!this.selectedNeighs) {
    this.selectedNeighs = [];
  }

  if (checked) {
    if (!this.selectedNeighs.includes(uid)) {
      this.selectedNeighs.push(uid);
    }
  } else {
    this.selectedNeighs = this.selectedNeighs.filter(e => e !== uid);
  }

  this.layerDataGroup.patchValue({
    neighborhood: this.selectedNeighs
  });
    // Get names for display
  const matchedNames = this.neighbourhoods
    .filter(n => this.selectedNeighs.includes(n.neigh_uid))
    .map(n => n.neigh_name);
  this.selectedNeighName = matchedNames.join(",");
}


// Clear search when dropdown closes to reset the filter
onDropdownClose() {
  this.searchNeigh = '';
}
    selectAll(checked: boolean) {
      if (checked) {
        const neighbourhood = this.neighbourhoods.map((neighbourhood:any) => neighbourhood?.neigh_uid);
        this.layerDataGroup.get("neighborhood").setValue(neighbourhood);
        this.selectedNeighs=neighbourhood;
      } else {
        this.layerDataGroup.get("neighborhood").setValue([]);
        this.selectedNeighs=[];

      }
          // Get names for display
  const matchedNames = this.neighbourhoods
    .filter(n => this.selectedNeighs.includes(n.neigh_uid))
    .map(n => n.neigh_name);
  this.selectedNeighName = matchedNames.join(",");
    }

/**
 * Ensure that whenever the dropdown opens, selections are restored
 */
onDropdownOpen() {
  // restore already selected when dropdown opens again
  if (this.selectedNeighs?.length) {
    this.layerDataGroup.patchValue({
      neighborhood: this.selectedNeighs
    }, { emitEvent: false });
  }
}


  selectionBlock(block){
    const blockArray = block;
    const matchedNames:any = this.blocks
  .filter(n => blockArray.includes(n.block_uid))
  .map(n => n.block_name);
   this.selectedBlockName = matchedNames.join(",");

  }

  /**
   * get block list based on neigh id
   * @param neighUid
   */
  getBlocks(neighUid) {
    let url = `blocks/json?neigh_uid=${neighUid}&return_geometry=true`;

    if (this.selectedYear) {
      url += `&year=${this.selectedYear}`;
    }
    this.blocks = [];
    this.loader = true;
    this.api.getGpsData(url).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.blocks = res;
      },
      error: () => {
        this.selectedBlock = null;
        this.loader = false;
        this.notify.notify("No Blocks found in this Neighbourhood", "warn");
      },
    });
  }

  /**
   *
   * @param layerType
   */
  getLayerData(layerType: any, status: any, initial: boolean = false): void {

    let year = this.selectedYear;
    if (initial) {
      year = new Date().getFullYear();
    }
    this.layerListData = [];

    if (!this.calculate_access.GET) {
      this.notify.notify("You are not authorized to get data", "warn");
      return;
    }

    if (this.fnc.checkResourceAccess("all_uploaded_file").GET) {
      this.is_admin = true;
    }
    if(this.layerDataGroup.value.layerName == 'amenity_distance'){
     this.getAmenities();
    }

    this.list.next();

    let url = `sync-calculate-process-spark?process_name=${this.layerDataGroup.value.layerName}&sort_asc=false&year=${year}&limit=${this.limit}&offset=${this.offset}&is_count=true&common_db_city_id=253`;

    if (layerType !== null && this.isPanelOpen) {
      url += `&neigh_uids=${layerType}`;
    }

    if (status !== null && this.isPanelOpen) {
      url += `&status=${status}`;
    }

    this.loader = true;
    this.api.getGesData(url).subscribe({
      next: (res: any) => {
        this.loader = false;
        if (res && res.status === 200) {
          this.layerListData = res.data.map(item => ({
            ...item,
            id: item.added_by === 0 ? `auto-${item.id}` : item.id
        }));

          this.list.next(res.data);
          this.totalCount = res.count || 0; // Update count or fallback to 0
          if (layerType == null && status == null) {
            this.getNeighborhood(res.data);
          }
        } else {
          this.totalCount = res.count || 0; // Update count or fallback to 0
          this.notify.notify(res.message || "Failed to fetch data", "warn");
        }
      },
      error: (err) => {
        console.error("Error fetching data:", err);
        this.loader = false;
        this.layerListData = [];
        this.totalCount = 0; // Reset count on error
      },
    });
  }

  /**
   * filter name list
   * @param datalist
   */
  getNeighborhood(datalist) {
    let list = [];
    let statusList = [];
    datalist.forEach((element) => {
      list.push(element.uid);
      statusList.push(element.status);
    });

    let result = list.reduce(
      (accumulator, value) => accumulator.concat(value),
      []
    );
    this.filteredStatus = statusList.filter(
      (item, index) => statusList.indexOf(item) === index
    );
    const uniqueArr = result.filter(
      (item, index) => result.indexOf(item) === index
    );
    this.filter_list_data = uniqueArr;
  }
  formValueReset() {
    this.layerDataGroup.reset({
      neighbourhoods: "",
      blocks: "",
      distance: "",
      zoning:"",
      geometryTypes: "",
    });
  }

  calculateSyncProcess() {
    if (!this.calculate_access.POST) {
      this.notify.notify("You are not authorized to calculate data", "warn");
      return;
    }
    if(!this.isServerRunning){
      this.notify.notify("The server must be running to perform the calculation. Please start the server and try again!", "warn");
      return
    }

    const getSelectedType = this.layerDataGroup.value.layerName; // Get selected layer type
    const block = this.layerDataGroup.value.block;

    const distance = this.layerDataGroup.value.distance;
    let zoning = this.layerDataGroup.value.zoning;
    const property_sub_cat = this.layerDataGroup.value.sub_categories || [];

    // Find the selected layer in the list of options
    const selectedLayer = layerListOptions.find(
      (layer) => layer.value === getSelectedType
    );
    // if (getSelectedType === "common_adm" && !this.selectedGeometryType) {
    //   this.notify.notify("Geometry type is required", "warn");
    //   this.isCalculating = false;
    //   return;
    // }
    if (!selectedLayer) {
      this.notify.notify("Invalid layer selection", "warn");
      this.isCalculating = false;
      return; // Exit if the layer type is not valid
    }


    // Set zoning to the actual value only if `getSelectedType` is `sikka_parcel`
    // Otherwise, set zoning to null
    zoning = getSelectedType === "sikka_parcel" ? zoning : null;

    // Set the appropriate URL based on the selected layer
    const layerTypeUrl = selectedLayer.url;

    // Build the URL for the API request
    let url = `${layerTypeUrl}?process_name=${getSelectedType}&added_by=${this.api.user_id}&year=${this.selectedYear}&common_db_city_id=253`;

    // Include zoning in the URL, whether it is a value or explicitly set to `null`
    url += `&zoning=${zoning}`;

    if (this.selectedNeighs) {
      url += `&neigh_uid=${this.selectedNeighs}&neigh_name=${this.selectedNeighName}`;
    }

    if (block?.length > 0) {
      url += `&block_uid=${block}&block_name=${this.selectedBlockName}`;
    }
    //   if (getSelectedType === "common_adm") {
    //   url += "&geometry_type=" + this.selectedGeometryType.join(",");
    // }
    if (property_sub_cat && property_sub_cat.length > 0) {
      url += `&sub_categories=${property_sub_cat.join(',')}`; // Add sub-categories
    }

    if (
      getSelectedType === "street_rays_180" ||
      getSelectedType === "highway_rays_90" ||
      getSelectedType === "amenity_distance" ||
      getSelectedType === "sikka_parcel"
    ) {
      url += `&distance=${distance}`;
    }
    this.isCalculating = true;
    this.loader = true;
    // Make the API call
    this.api.getGesData(url).subscribe({
      next: (res: any) => {
        this.loader = false;
        this.isCalculating = false;
        if (res && res.status === 200) {
          this.notify.notify(res.message, "success");
          this.getLayerData(null, null); // Refresh the layer data
        } else {
          this.notify.notify(res.message, "warn");
          this.loader = false;
        }
      },
      error: (err) => {
         this.isCalculating = false;
        this.layerListData = [];
        this.notify.notify(err.error.message, "error");
        this.loader = false;
      },
    });
  }


/**
 * Fetch amenities settings dynamically from the API.
 */
getAmenities() {
  const url = `settings?search_text=amenity_distance`;
  this.api.getGmsData(url).subscribe({
    next: (res: any) => {
      if (res.status === 200 && res.data.length) {
        const setting = res.data[0]; // Get the first item in the array
        const values = setting.value.split(','); // Split the value string into an array
        // Map each value to the required structure for the dropdown
        this.sub_categories = values.map((val: string) => ({
          value: val,
          viewValue: val
        }));
      } else {
        this.notify.notify(res.message, "warn");
      }
    },
    error: (err) => {
      console.error(err);
      this.notify.notify("Error fetching amenities", "warn");
    },
  });
}

  openPanel() {
    this.isPanelOpen = !this.isPanelOpen;
  }
  applyFilter(filter_by_name, status) {
    if (filter_by_name == null && status == null) {
      this.notify.notify(
        "Please select at least one option to apply the filter",
        "warn"
      );
      return;
    } else {
      this.getLayerData(filter_by_name, status);
      this.isPanelOpen = false;
    }
  }
  openFilter() {
    this.isPanelOpen = !this.isPanelOpen;
  }
  resetFilter() {
    this.getLayerData(null, null);
    this.isPanelOpen = false;
    this.layerDataGroup.patchValue({
      status: null,
      filter_neighborhood: null,
    });
  }
  layerSelectionReset() {
    this.selectedNeighs = [];
    this.blocks = [];
    this.layerDataGroup.patchValue({
      neighborhood: "",
    });
    this.layerDataGroup.patchValue({
      block: "",
    });
  }
  selectionGeometryType(event) {
    console.log(event, "event");
    this.selectedGeometryType = event


  }
pageChange(pageDetails: { limit: number; offset: number; pageIndex: number }) {
  console.log("Parent received pageChange ->", pageDetails);
  this.limit = pageDetails.limit;       // ✅ update limit
  this.offset = pageDetails.offset;
  this.pageIndex = pageDetails.pageIndex;
  this.getLayerData(null, null);
}
    // Handles the chosen year for the date picker
    handleYearSelected(year: number) {
      this.selectedYear = year;
      this.getLayerData(null, null);
      this.getNeighbourhoods();

    }

    checkServerStatus(event){
      this.isServerRunning = event
    }

    getSyncStatus() {
      let apiUrl = `get-blocks-for-calculation`;

      this.api.getGesData(apiUrl).subscribe({
        next: (response: any) => {
          if (response?.status === 200) {
            // const rawBlocks = response.data || [];
            // const formattedBlocks = rawBlocks.map((item: string) => {
            //   const [neighbourhood, block] = item.split(" => ").map(s => s.trim());
            //   return { neighbourhood, block: Number(block) };
            // });

            this.selectedData = response?.data;
            this.cdr.detectChanges(); // Force change detection
          } else {
            console.warn('Unexpected response:', response);
          }
        },
        error: (error) => {
          console.error("API Error:", error);
        },
        complete: () => {
          console.log("API call completed.");
        },
      });
    }
    cityReorderLoader(event){
      this.loader = event;
    }

    neighOptionToggled(event: MatOptionSelectionChange, neighUid: string) {
  // only act on real user input
  if (!event.isUserInput) return;

  // if option is deselected by user (i.e. now not selected)
  if (!event.source.selected) {
    // remove from persistedSelectedNeighs
    const idx = this.persistedSelectedNeighs.indexOf(neighUid);
    if (idx > -1) {
      this.persistedSelectedNeighs.splice(idx, 1);
    }

    // Also update any other state/form controls you maintain
    // Keep these in sync so [selected] doesn't re-enable the option
    const control = this.layerDataGroup.get('neighborhood');
    if (control) {
      // take current control value (array) and remove the uid
      const current: string[] = Array.isArray(control.value) ? [...control.value] : [];
      const newVal = current.filter(v => v !== neighUid);
      control.setValue(newVal);
      // if you want to trigger validators / valueChanges
      control.updateValueAndValidity();
    }

    // If you keep selectedNeighs / selectedNeighName, sync them too:
    if (this.selectedNeighs && Array.isArray(this.selectedNeighs)) {
      this.selectedNeighs = this.selectedNeighs.filter(v => v !== neighUid);
    }

    // update display name string
    const matchedNames = this.neighbourhoods
      .filter(n => (this.persistedSelectedNeighs || []).includes(n.neigh_uid))
      .map(n => n.neigh_name);
    this.selectedNeighName = matchedNames.join(',');

    // If you have other logic that depends on selection (eg getBlocks), call it:
    if ((this.persistedSelectedNeighs || []).length) {
      // this.getBlocks(this.persistedSelectedNeighs);
    } else {
      this.layerDataGroup.patchValue({ block: '' });
    }
  }
}


handleCtrlA(event: KeyboardEvent) {
  if (event.ctrlKey && event.key.toLowerCase() === 'a') {
    event.preventDefault();

    const all = this.neighbourhoods;
    const selected = this.selectedNeighs || [];

    // Toggle
    if (selected.length === all.length) {
      this.selectedNeighs = []; // unselect all
    } else {
      this.selectedNeighs = all.map(n => n.neigh_uid); // select all
    }

    // Patch form
    this.layerDataGroup.patchValue({
      neighborhood: this.selectedNeighs
    });

    // Update display names
    this.selectedNeighName = this.selectedNeighs
      .map(uid => {
        const n = all.find(x => x.neigh_uid === uid);
        return n?.neigh_name;
      })
      .join(',');

    event.stopPropagation();
  }
}

}
